import Service, { service } from '@ember/service';
import moment from 'moment-timezone';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';

import { query as emberDataQuery } from '@ember-data/legacy-compat/builders';

export default class ConfigurationHistoryRepo extends Service {
  @service store;
  @service systemConfig;
  @service currentUser;

  configurationHistories = this.store.peekAll('configuration-history');

  fetchConfigurationHistoriesForJem = task(waitFor(async (params = {}) => {
    return (await this.store.request(emberDataQuery('configuration-history', {
      locationId: params?.stationId,
      afterDate: this.currentUser.user.createdAt.toISOString(),
      notAcknowledgedByUser: this.currentUser.user.id,
    }))).content;
  }));

  createNewVersion = task(waitFor(async (treeItem, note, type) => {
    if (treeItem.type !== 'station') {
      return;
    }

    const configurationHistory = this.store.createRecord('configuration-history', {
      location: treeItem.asHistory(),
      versionDateString: moment().format('YYYY-MM-DD'),
      user: this.currentUser.user.toFragment(),
      note,
      type,
    });

    await configurationHistory.save();
  }));
}
